import React, { Component } from 'react'
import { toast } from 'react-toastify'

import { Get, Put, Post, Delete } from 'utils/axios-token'
import { Get as PublicGet } from 'utils/axios-template'
import Lang from 'Lang/General'

const AnchorLink = ( WrappedComponent ) => {
  class AnchorLinkWrappedComponent extends Component {
    state = {
      loading: false,
      selectedAnchorLink: {},
      anchorLinkData: {
        "name": "",
        "path": "",
        "site_id": 1,
        "anchor_id": "",
        "page_id": 1,
        "section_id": 1
      },
      anchorLinkModalOpen: false,
      anchorLinkModalUpdateOpen: false,
      anchorLinks: [],
      anchorError: {}
    }

    load = param => this.setState({ loading: param })

    requestSuccess = success => toast.success( success, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })

    requestError = error => toast.error( error, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })

    onChangeAnchorLinkHOC = ( key, val ) => this.setState({ [ key ]: val })

    getAnchorLinks = ( site_id, query ) => PublicGet(
      `/api/v1/sites/${ site_id }/anchor_links?query=${ query }`,
      this.getAnchorLinksSuccess,
      this.getAnchorLinksError,
      this.load
    )
    getAnchorLinksSuccess = payload => this.setState({ anchorLinks: payload.data })
    getAnchorLinksError = error => this.requestError( error )

    getSelectedAnchorLink = ( site_id, anchor_link_id ) => Get(
      `/api/v1/sites/sites/${ site_id }/anchor_links/${ anchor_link_id }`,
      this.getSelectedAnchorLinkSuccess,
      this.getSelectedAnchorLinkError,
      this.load
    )
    getSelectedAnchorLinkSuccess = payload => this.setState({ 
      selectedAnchorLink: payload, 
      anchorLinkModalUpdateOpen: true 
    })
    getSelectedAnchorLinkError = () => {}

    createAnchorLink = (site_id, data) => Post(
      `/api/v1/sites/sites/${ site_id }/anchor_links`,
      data,
      payload => this.createAnchorLinkSuccess( payload, site_id ),
      this.createAnchorLinkError,
      this.load
    )
    createAnchorLinkSuccess = (payload, site_id) => {
      this.requestSuccess( Lang[ 'CREATE_ANCHOR_LINK_SUCCESFULLY' ][ this.props.selectedLanguage ] )
      this.setState({ selectedAnchorLink: payload, anchorLinkModalOpen: false })
      this.getAnchorLinks( site_id, '' )
    }
    createAnchorLinkError = error => {
      this.requestError( Lang[ 'ENSURE_ANCHOR_LINK_FULFIL_REQUIREMENT' ][ this.props.selectedLanguage ] )
      this.setState({ anchorError: error })
    }

    updateAnchorLink = (site_id, data, id ) => Put(
      `/api/v1/sites/sites/${ site_id }/anchor_links/${ id }`,
      data,
      this.updateAnchorLinkSuccess,
      this.updateAnchorLinkError,
      this.load
    )
    updateAnchorLinkSuccess = payload => {
      this.requestSuccess( Lang[ 'UPDATE_ANCHOR_LINK_SUCCESFULLY' ][ this.props.selectedLanguage ] )
      this.setState({ selectedAnchorLink: payload, anchorLinkModalUpdateOpen: false })
    }
    updateAnchorLinkError = error => {
      this.requestError( Lang[ 'ENSURE_ANCHOR_LINK_FULFIL_REQUIREMENT' ][ this.props.selectedLanguage ] )
      this.setState({ anchorError: error })
    }

    removeAnchorLink = ( site_id, id ) => Delete(
      `/api/v1/sites/sites/${ site_id }/anchor_links/${ id }`,
      () => this.removeAnchorLinkSuccess( site_id ),
      this.removeAnchorLinkError,
      this.load
    )
    removeAnchorLinkSuccess = ( site_id ) => {
      this.requestSuccess( Lang[ 'REMOVE_ANCHOR_LINK_SUCCESSFULLY' ][ this.props.selectedLanguage ] )
      this.setState({ selectedAnchorLink: {} })
      this.getAnchorLinks( site_id, '' )
    }
    removeAnchorLinkError = error => this.requestError( error )

    render = () => {
      return(
        <WrappedComponent
          {...this.props}
          selectedAnchorLink={ this.state.selectedAnchorLink }
          getSelectedAnchorLink={ this.getSelectedAnchorLink }
          onLoadAnchorLink={ this.state.loading }
          onChangeAnchorLinkHOC={ this.onChangeAnchorLinkHOC }
          createAnchorLink={ this.createAnchorLink }
          anchorLinkData={ this.state.anchorLinkData }
          updateAnchorLink={ this.updateAnchorLink }
          removeAnchorLink={ this.removeAnchorLink }
          anchorLinkModalOpen={ this.state.anchorLinkModalOpen }
          anchorLinkModalUpdateOpen={ this.state.anchorLinkModalUpdateOpen }  
          getAnchorLinks={ this.getAnchorLinks }
          anchorLinks={ this.state.anchorLinks }
          anchorError={ this.state.anchorError }
        />
      )
    }
  }
  return AnchorLinkWrappedComponent
}
export default AnchorLink
